import { combineReducers } from "@reduxjs/toolkit";

import type { EditMapAction } from "domains/createMapDetail/actionTypes";
import { CreateMapTypes } from "domains/createMapDetail/actionTypes";
import type { CustomKeyIssueAction } from "domains/customKeyIssue/actionTypes";
import { CustomKeyIssueTypes } from "domains/customKeyIssue/actionTypes";
import type { CustomKeyIssueState } from "domains/customKeyIssue/types";
import { addUserOrLanguageChangeReset } from "entities/topics/reducerHelpers";

const initialState: CustomKeyIssueState = {
  topicSearch: { currentQuery: "", idsForQuery: {}, isPending: false },
  upload: { error: false, isCreateFormActive: false, isPending: false },
};

const topicSearch = (
  state = initialState.topicSearch,
  action: CustomKeyIssueAction,
): CustomKeyIssueState["topicSearch"] => {
  switch (action.type) {
    case CustomKeyIssueTypes.FETCH_TOPIC_SEARCH: {
      return {
        ...state,
        isPending: true,
      };
    }
    case CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_FULFILLED: {
      return {
        ...state,
        isPending: false,
        currentQuery: action.meta.query,
        idsForQuery: {
          ...state.idsForQuery,
          [action.meta.query]: action.payload.map((item) => item.id),
        },
      };
    }
    case CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_REJECTED: {
      return {
        ...state,
        isPending: false,
      };
    }
    case CustomKeyIssueTypes.RESET_TOPIC_SEARCH_IDS_FOR_QUERY: {
      return {
        ...state,
        idsForQuery: {},
      };
    }
    default:
      return state;
  }
};

const upload = (
  state = initialState.upload,
  action: CustomKeyIssueAction | EditMapAction,
): CustomKeyIssueState["upload"] => {
  switch (action.type) {
    case CustomKeyIssueTypes.CREATE:
      return {
        ...state,
        isPending: true,
        error: false,
      };
    case CustomKeyIssueTypes.CREATE_FULFILLED:
      return {
        ...state,
        isPending: false,
        isCreateFormActive: false,
        entityId: undefined,
        error: false,
      };
    case CustomKeyIssueTypes.CREATE_REJECTED:
      return {
        ...state,
        isPending: false,
        error: true,
      };
    case CustomKeyIssueTypes.ACTIVATE_FORM:
      return {
        ...state,
        isCreateFormActive: action.meta?.isActive ?? !state.isCreateFormActive,
        entityId: action.meta?.id,
        error: false,
      };
    case CreateMapTypes.ADD_NEW_CUSTOM_KEY_ISSUE:
      return {
        ...state,
        isCreateFormActive: false,
        error: false,
      };
    default:
      return state;
  }
};

export const customKeyIssueReducer = combineReducers({
  topicSearch: addUserOrLanguageChangeReset(topicSearch, initialState.topicSearch),
  upload: addUserOrLanguageChangeReset(upload, initialState.upload),
});
